module.exports = __webpack_public_path__ + "media/packs/images/close-button-4659348e822ce7c36590983ba65e04a1.png";